import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FileWarning, PenLine, BookOpen, Receipt, CheckCircle2, ChevronDown } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const d = (s) => (s ? new Date(s).toLocaleDateString("de-DE") : "");
const eur = (v) => `${Number(v || 0).toLocaleString("de-DE", { minimumFractionDigits: 2 })} €`;

const Gruppe = ({ icon: Icon, titel, eintraege, ziel, zeile, testid }) => {
  const [offen, setOffen] = useState(false);
  const navigate = useNavigate();
  const ok = eintraege.length === 0;
  return (
    <div className={`rounded-xl border p-4 ${ok ? "border-emerald-200 bg-emerald-50/50" : "border-[#F8D6C3] bg-[#FEF4EE]"}`} data-testid={testid}>
      <button className="w-full flex items-center justify-between gap-3 text-left" onClick={() => !ok && setOffen(!offen)} data-testid={`${testid}-toggle`}>
        <div className="flex items-center gap-3">
          {ok ? <CheckCircle2 className="h-5 w-5 text-emerald-600" /> : <Icon className="h-5 w-5 text-[#C2410C]" />}
          <div>
            <p className="font-semibold text-stone-900">{titel}</p>
            <p className="text-xs text-stone-600">{ok ? "Nichts offen" : `${eintraege.length} offen`}</p>
          </div>
        </div>
        {!ok && <ChevronDown className={`h-4 w-4 text-stone-500 transition-transform ${offen ? "rotate-180" : ""}`} />}
      </button>
      {offen && (
        <ul className="mt-3 divide-y divide-[#F8D6C3] text-sm">
          {eintraege.slice(0, 100).map((e, i) => (
            <li key={i} className="py-2 flex items-center justify-between gap-3">
              <span className="text-stone-800">{zeile(e)}</span>
              <button onClick={() => navigate(ziel)} className="text-xs font-medium text-[#C2410C] hover:underline shrink-0">öffnen</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export const AutoTodos = () => {
  const [daten, setDaten] = useState(null);
  useEffect(() => { axios.get(`${API}/aufgaben-automatisch`).then((r) => setDaten(r.data)).catch(() => setDaten(null)); }, []);
  if (!daten) return null;
  return (
    <section className="mb-8" data-testid="auto-todos">
      <div className="flex items-baseline justify-between mb-3">
        <h2 className="text-lg font-semibold text-stone-900">Automatisch erkannt – was wirklich offen ist</h2>
        <span className="text-xs text-stone-500">Stand {daten.stand}</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <Gruppe icon={FileWarning} titel="Fehlende Pflichtunterlagen (BG-Teilnehmende)" testid="todo-unterlagen" ziel="/teilnehmer"
          eintraege={daten.fehlende_unterlagen} zeile={(e) => <><b>{e.name}</b> · fehlt: {e.fehlt.join(", ")}</>} />
        <Gruppe icon={PenLine} titel="Unterschrift seit über 3 Tagen offen" testid="todo-unterschriften" ziel="/teilnehmer"
          eintraege={daten.offene_unterschriften} zeile={(e) => <><b>{e.name}</b> · gesendet {d(e.gesendet_am)}</>} />
        <Gruppe icon={BookOpen} titel="Klassenbuch-Tage nicht abgeschlossen" testid="todo-klassenbuch" ziel="/klassenbuch-neu"
          eintraege={daten.klassenbuch_offen} zeile={(e) => <><b>{d(e.datum)}</b> · {e.kurs}</>} />
        <Gruppe icon={Receipt} titel="Überfällige Rechnungen" testid="todo-rechnungen" ziel="/rechnungen"
          eintraege={daten.rechnungen_ueberfaellig} zeile={(e) => <><b>{e.rechnungsnummer}</b> · {e.empfaenger_name} · {eur(e.endbetrag)} · fällig {d(e.zahlungsziel)}</>} />
      </div>
      <h2 className="text-lg font-semibold text-stone-900 mt-8">Eigene Aufgaben</h2>
    </section>
  );
};
